<template>
  <div class="program-current-day">
    <div class="program-current-day__previous-day" v-if="previousDay">
      <nuttrema-iconica-sidebar-link
         icon="far fa-angle-left"
         theme="white"
        :title="$t('label.previous_day')"
        @click="gotoPreviousDay">
      </nuttrema-iconica-sidebar-link>
    </div>
    <div v-if="currentDay.day">
      <div class="current-day-number">{{ currentDay.day | moment('Do') }}</div>
      <div class="current-day-title">{{ currentDay.day | moment('MMMM, YYYY') }}</div>
    </div>
    <div v-if="!currentDay.day">
      <div class="current-day-number">{{ currentDay.day_number }}</div>
      <div class="current-day-title">{{ $t('label.day_of_diet') }}</div>
    </div>
    <div class="program-current-day__next-day" v-if="nextDay">
      <nuttrema-iconica-sidebar-link
         icon="far fa-angle-right"
         theme="white"
        :title="$t('label.next_day')"
        @click="gotoNextDay">
      </nuttrema-iconica-sidebar-link>
    </div>
  </div>
</template>

<script>
import { find, isEmpty, findIndex } from 'lodash';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

export default {
  name: 'cmpt-program-current-day',
  props: {
    dayID: {
      required: true,
      default: null,
    },
    programDays: {
      type: Array,
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaIconicaSidebarLink,
  },
  computed: {
    currentDay() {
      return this.findCurrentDay();
    },
    previousDay() {
      const current = this.findCurrentDay();
      const index = findIndex(this.programDays, item => item.id === current.id);
      if (index > 0 && !isEmpty(this.programDays[index - 1])) return this.programDays[index - 1];
      return null;
    },
    nextDay() {
      const current = this.findCurrentDay();
      const index = findIndex(this.programDays, item => item.id === current.id);
      if (index < this.programDays.length && !isEmpty(this.programDays[index + 1])) return this.programDays[index + 1];
      return null;
    },
  },
  methods: {
    findCurrentDay() {
      return find(this.programDays, item => Number(item.id) === Number(this.dayID));
    },
    gotoPreviousDay() {
      this.$emit('gotoDay', this.previousDay.id);
    },
    gotoNextDay() {
      this.$emit('gotoDay', this.nextDay.id);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  .program-current-day {
    width: 100%;
    padding: 0.6em;
    text-align: center;
    position: relative;
    border-bottom: 1px solid #dfe6ec;

    .current-day-number {
      font-size: 2.5rem;
      line-height: 1;
      font-weight: 800;
    }
    .current-day-title {
      font-weight: 400;
      color: $gray;
    }

    .program-current-day__previous-day {
      position: absolute;
      left: 0.5em; top: 0.75em;
    }

    .program-current-day__next-day {
      position: absolute;
      right: 0.5em; top: 0.75em;
    }

    .program-current-day__previous-day, .program-current-day__next-day {
      visibility: hidden;
      opacity: 0;
      transition: all 0.5s linear;
    }

    &:hover {
      .program-current-day__previous-day, .program-current-day__next-day {
        visibility: visible;
        opacity: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/schedules/list/cmpt-program-current-day.vue